import ArrowLeftTwoIcon from "@assets/icons/arrowLeftTwo"
import { Button } from "@components/Button"
import usePatient from "@hooks/usePatient"
import { useSelector } from "react-redux"
import { useSearchParams } from "react-router-dom"

export const DeleteDisorder = ({
  selectedExercisesToDelete,
  onClose,
  onSuccess,
  path,
  diagnosisId,
  patientId,
}) => {
  const { handleGetSinglePatient, handleUpdateDiagnosis } = usePatient()
  const { isUpdateDiagnosisLoading } = useSelector((state) => state.patient)

  const [searchParams] = useSearchParams()
  const searchParamPatientId = searchParams.get("_id")
  // Use provided patientId if available, otherwise fall back to URL params
  const effectivePatientId = patientId || searchParamPatientId

  const closeDeletePrescribeExercise = () => {
    onClose()
  }

  const removeExerciseSuccess = () => {
    handleGetSinglePatient({ _id: effectivePatientId })
    onSuccess()
  }

  const handleDeleteDisorder = () => {
    // Update to use the requested body structure
    handleUpdateDiagnosis(
      {
        patientId: effectivePatientId,
        diagnosisId: diagnosisId,
        isDeleted: true,
      },
      removeExerciseSuccess
    )
  }

  return (
    <div className="fixed right-0 left-0 bottom-0 top-0 bg-[#25323E3D] z-[1000] flex items-center justify-center p-4">
      <div className="min-h-[280px] w-full max-w-[48rem] flex flex-col rounded-2xl border border-[#63B1FC] bg-white overflow-hidden">
        <div className="flex flex-col items-center rounded-t-2xl justify-center gap-3 md:gap-4 bg-[--pure-white] grow p-4 md:p-6">
          <h1 className="text-lg md:text-3xl text-[--text-light-grey] text-center font-medium">
            Delete Added Disorder
          </h1>
          <div className="flex flex-col gap-2 md:gap-4 max-h-[20vh] md:max-h-[30vh] overflow-y-auto w-full px-2">
            {[...selectedExercisesToDelete].map((item, index) => {
              return (
                <h2
                  key={index}
                  className="text-[--text-light-grey] text-xs md:text-sm tracking-widest font-bold text-center"
                >
                  {item}
                </h2>
              )
            })}
          </div>
          <p className="text-[--text-light-grey] text-xs md:text-sm text-center px-2 md:px-4">
            Deleting the already added disorder from the patient diagnosis
            cannot be undone.
          </p>
        </div>
        <div className="p-4 md:p-8 flex flex-wrap gap-3 md:gap-6 rounded-b-2xl items-center justify-center md:justify-end h-auto md:h-[6.75rem] bg-[#ECF6FF]">
          <Button
            onClick={closeDeletePrescribeExercise}
            variant="transparent"
            className="!bg-[--pure-white] !tracking-widest !font-[Roboto] !text-[--primary-blue] font-medium text-xs md:text-sm py-2 px-3 md:px-4"
          >
            <ArrowLeftTwoIcon className="w-4 h-4 md:w-5 md:h-5" />
            BACK
          </Button>
          <Button
            loading={isUpdateDiagnosisLoading}
            onClick={handleDeleteDisorder}
            className="!text-[#B90022] !bg-[--pure-white] !tracking-widest !font-[Roboto] font-medium text-xs md:text-sm py-2 px-3 md:px-4"
          >
            YES, DELETE
          </Button>
        </div>
      </div>
    </div>
  )
}
